import { v4 as uuid } from "uuid";

export const generateChatSessionId = () => {
  return uuid();
};

//encoder function
export const encodeBase64 = (str: string) => {
  if (!str) return "";

  const bytes = new TextEncoder().encode(str);
  const binString = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join("");
  return btoa(binString);
};
